import { render, staticRenderFns } from "./LmDocumentsPrivileges.vue?vue&type=template&id=1528f2ee"
import script from "./LmDocumentsPrivileges.vue?vue&type=script&lang=js"
export * from "./LmDocumentsPrivileges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports